import FormField from './FormField';

export default class FormFieldText extends FormField
{

}
